var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "90%",
            title: _vm.showTitle(),
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "3vh",
            "custom-class": "update-student-dialog sk-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formAllTabStudent",
              staticClass: "update-student-form",
              attrs: {
                model: _vm.formAllTabStudent,
                rules: _vm.rules,
                "label-width": "150px",
                "label-position": "left",
              },
            },
            [
              _c("div", { staticClass: "update-student-content" }, [
                _c(
                  "div",
                  { staticClass: "student-panel" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "update-student-tabs",
                        attrs: { type: "card" },
                        on: { "tab-click": _vm.handleClickTab },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { label: "Thông tin", name: "commonInfor" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "common-info-tab" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 24 } },
                                  [
                                    _c("el-col", { attrs: { span: 6 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "profile-sidebar-card" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-avatar-wrap",
                                            },
                                            [
                                              (_vm.formAllTabStudent.kidMainInfo
                                                .avatarKid != null &&
                                                _vm.showPictureInitial) ||
                                              _vm.imageUrlPreview
                                                ? _c("el-image", {
                                                    staticClass:
                                                      "profile-avatar",
                                                    attrs: {
                                                      src: _vm.imageUrlPreview
                                                        ? _vm.imageUrlPreview
                                                        : _vm.formAllTabStudent
                                                            .kidMainInfo
                                                            .avatarKid,
                                                      fit: "cover",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("el-upload", {
                                                ref: "upload",
                                                staticStyle: {
                                                  display: "none",
                                                },
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  "show-file-list": false,
                                                  "on-change":
                                                    _vm.handleChangeUpload,
                                                  "on-remove": _vm.handleRemove,
                                                  "auto-upload": false,
                                                  action: "",
                                                },
                                              }),
                                              !(
                                                (_vm.formAllTabStudent
                                                  .kidMainInfo.avatarKid !=
                                                  null &&
                                                  _vm.showPictureInitial) ||
                                                _vm.imageUrlPreview
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-trigger-area",
                                                      on: {
                                                        click:
                                                          _vm.triggerAvatarUpload,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-plus",
                                                      }),
                                                      _c("span", [
                                                        _vm._v("Thêm ảnh"),
                                                      ]),
                                                    ]
                                                  )
                                                : !_vm.showDetail
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-actions-overlay",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn edit-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title:
                                                              "Thay đổi ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.triggerAvatarUpload,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-edit-outline",
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn delete-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title: "Xóa ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleRemove,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-code-section",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "profile-code-label",
                                                },
                                                [_vm._v("Mã học sinh")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "profile-code-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formAllTabStudent
                                                        .kidMainInfo.kidCode
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-status-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [_vm._v("Trạng thái học tập")]
                                              ),
                                              _c(
                                                "el-radio-group",
                                                {
                                                  staticClass:
                                                    "status-radio-group",
                                                  attrs: {
                                                    disabled: _vm.showDetail,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.changeKidsStatus()
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabStudent
                                                        .kidMainInfo.kidStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabStudent
                                                          .kidMainInfo,
                                                        "kidStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabStudent.kidMainInfo.kidStatus",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "STUDYING",
                                                      },
                                                    },
                                                    [_vm._v("Đang học")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "STUDY_WAIT",
                                                      },
                                                    },
                                                    [_vm._v("Chờ học")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "RESERVE",
                                                      },
                                                    },
                                                    [_vm._v("Bảo lưu")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "LEAVE_SCHOOL",
                                                      },
                                                    },
                                                    [_vm._v("Nghỉ học")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "transition",
                                                {
                                                  attrs: {
                                                    name: "el-zoom-in-top",
                                                  },
                                                },
                                                [
                                                  _vm.formAllTabStudent
                                                    .kidMainInfo.kidStatus ==
                                                    "RESERVE" ||
                                                  _vm.formAllTabStudent
                                                    .kidMainInfo.kidStatus ==
                                                    "LEAVE_SCHOOL"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "status-date-wrap",
                                                        },
                                                        [
                                                          _vm.formAllTabStudent
                                                            .kidMainInfo
                                                            .kidStatus ==
                                                          "RESERVE"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "kidMainInfo.dateRetain",
                                                                    label:
                                                                      "Ngày bảo lưu",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày bảo lưu",
                                                                        disabled:
                                                                          _vm.showDateStatus,
                                                                        "picker-options":
                                                                          _vm.pickerOptions2,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabStudent
                                                                            .kidMainInfo
                                                                            .dateRetain,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabStudent
                                                                                .kidMainInfo,
                                                                              "dateRetain",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabStudent.kidMainInfo.dateRetain",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm.formAllTabStudent
                                                            .kidMainInfo
                                                            .kidStatus ==
                                                          "LEAVE_SCHOOL"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "kidMainInfo.dateLeave",
                                                                    label:
                                                                      "Ngày nghỉ học",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày nghỉ học",
                                                                        disabled:
                                                                          _vm.showDateStatus,
                                                                        "picker-options":
                                                                          _vm.pickerOptions2,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabStudent
                                                                            .kidMainInfo
                                                                            .dateLeave,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabStudent
                                                                                .kidMainInfo,
                                                                              "dateLeave",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabStudent.kidMainInfo.dateLeave",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-bank-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [
                                                  _vm._v(
                                                    "Tài khoản thu học phí"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bank-card-preview",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-bank-card card-chip-icon",
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bank-detail-row",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [_vm._v("Ngân hàng:")]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.bankName ||
                                                                "Chưa liên kết"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bank-detail-row",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Số tài khoản:"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "value monospace",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.accountNumber ||
                                                                "N/A"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bank-detail-row",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Chủ tài khoản:"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "value font-semibold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userBank ||
                                                                "N/A"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.showButtonClick
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bank-change-wrap",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bank-change-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Thay đổi tài khoản thu"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "margin-top": "6px",
                                                          },
                                                          attrs: {
                                                            filterable: "",
                                                            placeholder:
                                                              "Chọn tài khoản ngân hàng",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo
                                                                .idFnBank,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo,
                                                                "idFnBank",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabStudent.kidMainInfo.idFnBank",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.responseList,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  value:
                                                                    item.id,
                                                                  label:
                                                                    item.bankName,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "info-section-card" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-inner-title" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-user",
                                              }),
                                              _vm._v(" Thông tin học sinh"),
                                            ]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Khối học",
                                                        prop: "kidMainInfo.gradeName",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "read-only-input",
                                                        attrs: { disabled: "" },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .gradeName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "gradeName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.gradeName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Lớp học",
                                                        prop: "kidMainInfo.className",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "read-only-input",
                                                        attrs: { disabled: "" },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .className,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "className",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.className",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 14 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          "Họ tên học sinh",
                                                        prop: "kidMainInfo.fullName",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .fullName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "fullName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.fullName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Biệt danh",
                                                        prop: "kidMainInfo.nickName",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .nickName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "nickName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.nickName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 14 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày sinh",
                                                        prop: "kidMainInfo.birthDay",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          format: "dd-MM-yyyy",
                                                          "picker-options":
                                                            _vm.pickerOptions,
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .birthDay,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "birthDay",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.birthDay",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "kidMainInfo.gender",
                                                        label: "Giới tính",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio-group",
                                                        {
                                                          staticClass:
                                                            "gender-radio-group",
                                                          attrs: {
                                                            disabled:
                                                              _vm.showDetail,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo
                                                                .gender,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo,
                                                                "gender",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabStudent.kidMainInfo.gender",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nam",
                                                              },
                                                            },
                                                            [_vm._v("Nam")]
                                                          ),
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nữ",
                                                              },
                                                            },
                                                            [_vm._v("Nữ")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 14 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày nhập học",
                                                        prop: "kidMainInfo.dateStart",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .dateStart,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "dateStart",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.dateStart",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Dân tộc",
                                                        prop: "kidMainInfo.ethnic",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .ethnic,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "ethnic",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.ethnic",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "kidMainInfo.representation",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                          },
                                                          slot: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Người đại diện\n                          "
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  "Thông tin người đại diện sẽ được dùng để áp dụng cho HĐ điện tử",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-info",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-radio-group",
                                                        {
                                                          staticClass:
                                                            "gender-radio-group",
                                                          attrs: {
                                                            disabled:
                                                              _vm.showDetail,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo
                                                                .representation,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo,
                                                                "representation",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabStudent.kidMainInfo.representation",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Bố",
                                                              },
                                                            },
                                                            [_vm._v("Bố")]
                                                          ),
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Mẹ",
                                                              },
                                                            },
                                                            [_vm._v("Mẹ")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 14 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "kidMainInfo.identificationNumber",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                          },
                                                          slot: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Số định danh\n                          "
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  "Số định danh của học sinh",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-info",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabStudent
                                                              .kidMainInfo
                                                              .identificationNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabStudent
                                                                .kidMainInfo,
                                                              "identificationNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabStudent.kidMainInfo.identificationNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Địa chỉ hiện tại",
                                                prop: "kidMainInfo.address",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabStudent
                                                      .kidMainInfo.address,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabStudent
                                                        .kidMainInfo,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabStudent.kidMainInfo.address",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "kidMainInfo.permanentAddress",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "label" },
                                                  slot: "label",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Địa chỉ thường trú\n                      "
                                                  ),
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          "Địa chỉ thường trú của học sinh được sử dụng để áp dụng cho HĐ điện tử",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-info",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabStudent
                                                      .kidMainInfo
                                                      .permanentAddress,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabStudent
                                                        .kidMainInfo,
                                                      "permanentAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabStudent.kidMainInfo.permanentAddress",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Ghi chú",
                                                prop: "kidMainInfo.note",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  type: "textarea",
                                                  rows: 2,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabStudent
                                                      .kidMainInfo.note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabStudent
                                                        .kidMainInfo,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabStudent.kidMainInfo.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "column-parent-flex" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info-section-card parent-card",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-inner-title",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-male",
                                                  }),
                                                  _vm._v(" Thông tin Bố"),
                                                ]
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Họ tên bố",
                                                            prop: "kidMainInfo.fatherName",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherName",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherName",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Ngày sinh",
                                                            prop: "kidMainInfo.fatherBirthday",
                                                          },
                                                        },
                                                        [
                                                          _c("el-date-picker", {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              format:
                                                                "dd-MM-yyyy",
                                                              "picker-options":
                                                                _vm.pickerOptions,
                                                              "value-format":
                                                                "yyyy-MM-dd",
                                                              type: "date",
                                                              placeholder:
                                                                "Chọn ngày",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherBirthday,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherBirthday",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherBirthday",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Số điện thoại",
                                                            prop: "kidMainInfo.fatherPhone",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              type: "number",
                                                              min: "0",
                                                              max: "0",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherPhone,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherPhone",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherPhone",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "CCCD bố",
                                                            prop: "kidMainInfo.fatherCitizenIdentification",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherCitizenIdentification,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherCitizenIdentification",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherCitizenIdentification",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Email",
                                                            prop: "kidMainInfo.fatherEmail",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherEmail,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherEmail",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherEmail",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Nghề nghiệp",
                                                            prop: "kidMainInfo.fatherJob",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .fatherJob,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "fatherJob",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.fatherJob",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info-section-card parent-card",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-inner-title",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-female",
                                                  }),
                                                  _vm._v(" Thông tin Mẹ"),
                                                ]
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Họ tên mẹ",
                                                            prop: "kidMainInfo.motherName",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherName",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherName",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Ngày sinh",
                                                            prop: "kidMainInfo.motherBirthday",
                                                          },
                                                        },
                                                        [
                                                          _c("el-date-picker", {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              format:
                                                                "dd-MM-yyyy",
                                                              "picker-options":
                                                                _vm.pickerOptions,
                                                              "value-format":
                                                                "yyyy-MM-dd",
                                                              type: "date",
                                                              placeholder:
                                                                "Chọn ngày",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherBirthday,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherBirthday",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherBirthday",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Số điện thoại",
                                                            prop: "kidMainInfo.motherPhone",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              type: "number",
                                                              min: "0",
                                                              max: "0",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherPhone,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherPhone",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherPhone",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "CCCD mẹ",
                                                            prop: "kidMainInfo.motherCitizenIdentification",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherCitizenIdentification,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherCitizenIdentification",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherCitizenIdentification",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Email",
                                                            prop: "kidMainInfo.motherEmail",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherEmail,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherEmail",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherEmail",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Nghề nghiệp",
                                                            prop: "kidMainInfo.motherJob",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .motherJob,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "motherJob",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.motherJob",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info-section-card parent-card",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-inner-title",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-wallet",
                                                  }),
                                                  _vm._v(
                                                    " Thông tin tài chính hoàn phí"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "Mã số thuế",
                                                            prop: "kidMainInfo.taxIdentificationNumber",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .taxIdentificationNumber,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "taxIdentificationNumber",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.taxIdentificationNumber",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Chủ tài khoản",
                                                            prop: "kidMainInfo.accountHolderStudent",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .accountHolderStudent,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "accountHolderStudent",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.accountHolderStudent",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                { attrs: { gutter: 16 } },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Tên ngân hàng",
                                                            prop: "kidMainInfo.bankNameStudent",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .bankNameStudent,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "bankNameStudent",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.bankNameStudent",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Số tài khoản",
                                                            prop: "kidMainInfo.accountNumberStudent",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.showDetail,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .formAllTabStudent
                                                                  .kidMainInfo
                                                                  .accountNumberStudent,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formAllTabStudent
                                                                      .kidMainInfo,
                                                                    "accountNumberStudent",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "formAllTabStudent.kidMainInfo.accountNumberStudent",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: "Sức khỏe chung",
                              name: "extraInfo",
                            },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "margin-left": "20%" },
                                attrs: { span: 15 },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Nhóm máu",
                                      prop: "bloodType",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập nhóm máu",
                                      },
                                      model: {
                                        value:
                                          _vm.kidsExtraInfoUpdate.bloodType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "bloodType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "kidsExtraInfoUpdate.bloodType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Bơi", prop: "swim" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập bơi",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.swim,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "swim",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.swim",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Dị ứng", prop: "allery" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập dị ứng",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.allery,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "allery",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "kidsExtraInfoUpdate.allery",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Ăn kiêng", prop: "diet" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập ăn kiêng",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.diet,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "diet",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.diet",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Tai", prop: "ear" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập tai",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.ear,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "ear",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.ear",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Mũi", prop: "nose" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập mũi",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.nose,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "nose",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.nose",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Họng", prop: "throat" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập họng",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.throat,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "throat",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "kidsExtraInfoUpdate.throat",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Da", prop: "skin" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập da",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.skin,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "skin",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.skin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Mắt", prop: "eyes" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập mắt",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.eyes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "eyes",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.eyes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Tim", prop: "heart" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập tim",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.heart,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "heart",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.heart",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Béo phì", prop: "fat" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.showDetail,
                                        clearable: "",
                                        placeholder: "Nhập béo phì",
                                      },
                                      model: {
                                        value: _vm.kidsExtraInfoUpdate.fat,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.kidsExtraInfoUpdate,
                                            "fat",
                                            $$v
                                          )
                                        },
                                        expression: "kidsExtraInfoUpdate.fat",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { label: "App Onekids", name: "appOnekids" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-1",
                                attrs: {
                                  border: "",
                                  data: _vm.parentIconAppUpdate
                                    .parentIconUpdate1,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    type: "index",
                                    label: "STT",
                                    align: "center",
                                    width: "50",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Hiển thị",
                                    align: "center",
                                    width: "80",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            attrs: { disabled: _vm.showDetail },
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Mở khóa",
                                    align: "center",
                                    width: "80",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-2",
                                attrs: {
                                  border: "",
                                  data: _vm.parentIconAppUpdate
                                    .parentIconUpdate2,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    type: "index",
                                    label: "STT",
                                    align: "center",
                                    width: "50",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Hiển thị",
                                    align: "center",
                                    width: "80",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            attrs: { disabled: _vm.showDetail },
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Mở khóa",
                                    align: "center",
                                    width: "80",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        this.appType === "plus"
                          ? _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Cấu hình Cam",
                                  name: "commonConfig",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 5, offset: 7 } },
                                      [
                                        _c("el-checkbox", {
                                          attrs: { disabled: _vm.showDetail },
                                          model: {
                                            value:
                                              _vm.formAllTabStudent.kidMainInfo
                                                .oneCamStatus,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabStudent
                                                  .kidMainInfo,
                                                "oneCamStatus",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabStudent.kidMainInfo.oneCamStatus",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Cho phép xem Camera ở OneCamPlus không?"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { offset: 7 } },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            ref: "multipleTable",
                                            staticStyle: {
                                              width: "700px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "element-loading-spinner":
                                                "el-icon-loading",
                                              "element-loading-background":
                                                "rgba(255,255,255, 0)",
                                              data: _vm.kidCamList,
                                              "highlight-current-row": "",
                                              "header-cell-style":
                                                _vm.tableHeaderColor,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "index",
                                                label: "STT",
                                                width: "50",
                                                align: "center",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "cameraName",
                                                label: "Tên cam",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "active",
                                                label: "Trạng thái",
                                                width: "100px",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-checkbox", {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              scope.row
                                                                .existClass ||
                                                              _vm.showDetail,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.active,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "active",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.active",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4043553361
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tác vụ",
                                                width: "120",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                scope.row
                                                                  .existClass ||
                                                                !scope.row
                                                                  .active ||
                                                                _vm.showDetail,
                                                              size: "mini",
                                                              type: "success",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSettingCame(
                                                                  scope.row
                                                                    .idCamera,
                                                                  scope.row
                                                                    .cameraName
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Thiết lập\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2071202776
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.showDetail &&
                        _vm.checkPermission(["recognition-manager"])
                          ? _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Quản lý nhận diện AI",
                                  name: "faceManagement",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value: _vm.loadingRecognition,
                                                expression:
                                                  "loadingRecognition",
                                              },
                                            ],
                                            ref: "faceManagement",
                                            staticClass: "ai-management-form",
                                            attrs: {
                                              model: _vm.kidFaceManagement,
                                              "label-position": "top",
                                              "element-loading-text":
                                                "Loading...",
                                              "element-loading-spinner":
                                                "el-icon-loading",
                                              "element-loading-background":
                                                "rgba(0, 0, 0, 0.8)",
                                              rules: _vm.rulesFaceManagement,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "ai-layout" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ai-panel ai-panel-intro",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ai-panel-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Thiết lập nhận diện AI"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ai-panel-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Cập nhật khuôn mặt, thiết bị, thẻ và vân tay cho học sinh."
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-row",
                                                  {
                                                    staticClass:
                                                      "ai-upper-layout",
                                                    attrs: { gutter: 20 },
                                                  },
                                                  [
                                                    _vm.checkPermission([
                                                      "recognition-manager-face-student",
                                                    ])
                                                      ? _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 8 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-panel ai-avatar-panel",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ai-panel-inner-title required",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Ảnh chân dung nhận diện"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "ai-face-form-item",
                                                                    attrs: {
                                                                      prop: "urlWebFace",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-avatar-scanner",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-avatar-scanner-view",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner top-left",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner top-right",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner bottom-left",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner bottom-right",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-line",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-avatar-box",
                                                                              },
                                                                              [
                                                                                _vm
                                                                                  .kidFaceManagement
                                                                                  .urlWebFace &&
                                                                                !_vm.checkCreateRecognition &&
                                                                                !_vm.facePreviewUrl
                                                                                  ? _c(
                                                                                      "el-image",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-preview",
                                                                                        attrs:
                                                                                          {
                                                                                            src: _vm
                                                                                              .kidFaceManagement
                                                                                              .urlWebFace,
                                                                                            fit: "cover",
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _vm.facePreviewUrl
                                                                                  ? _c(
                                                                                      "el-image",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-preview",
                                                                                        attrs:
                                                                                          {
                                                                                            src: _vm.facePreviewUrl,
                                                                                            fit: "cover",
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-empty",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-camera",
                                                                                          }
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Chưa có ảnh"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-upload",
                                                                          {
                                                                            ref: "uploadFace",
                                                                            staticClass:
                                                                              "ai-upload-face-hidden",
                                                                            attrs:
                                                                              {
                                                                                "show-file-list": false,
                                                                                "on-change":
                                                                                  _vm.handleChangeUploadFace,
                                                                                "auto-upload": false,
                                                                                accept:
                                                                                  "image/jpeg,image/png",
                                                                                action:
                                                                                  "",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-face-actions",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    type: "primary",
                                                                                    icon: "el-icon-upload2",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.triggerFaceUpload,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.hasFaceImage
                                                                                      ? "Sửa ảnh"
                                                                                      : "Thêm ảnh"
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    type: "danger",
                                                                                    icon: "el-icon-delete",
                                                                                    disabled:
                                                                                      !_vm.hasFaceImage,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.handleDeleteFace,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Xóa"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    icon: "el-icon-zoom-in",
                                                                                    disabled:
                                                                                      !_vm.hasFaceImage,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.handlePreviewFace,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Xem"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-avatar-note",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-info",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Ảnh chân dung rõ nét sẽ giúp thiết bị AI nhận diện học sinh ổn định hơn."
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-dialog",
                                                                  {
                                                                    attrs: {
                                                                      visible:
                                                                        _vm.facePreviewDialogVisible,
                                                                      title:
                                                                        "Xem ảnh chân dung",
                                                                      width:
                                                                        "500px",
                                                                      "append-to-body":
                                                                        "",
                                                                      "custom-class":
                                                                        "face-preview-dialog",
                                                                    },
                                                                    on: {
                                                                      "update:visible":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.facePreviewDialogVisible =
                                                                            $event
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "face-preview-wrap",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: _vm.facePreviewDialogUrl,
                                                                                alt: "Ảnh chân dung",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "el-col",
                                                      {
                                                        attrs: {
                                                          span: _vm.checkPermission(
                                                            [
                                                              "recognition-manager-face-student",
                                                            ]
                                                          )
                                                            ? 16
                                                            : 24,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ai-panel ai-form-panel",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-panel-inner-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Cấu hình thông tin"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Thiết bị hiện tại để truy vấn",
                                                                          prop: "idDevice",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Chọn thiết bị truy vấn",
                                                                                "value-key":
                                                                                  "id",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCurrentDeviceChange,
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .idDevice,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "idDevice",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.idDevice",
                                                                              },
                                                                          },
                                                                          _vm._l(
                                                                            _vm.listIdDevice,
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key: item.id,
                                                                                  attrs:
                                                                                    {
                                                                                      value:
                                                                                        item.id,
                                                                                      label:
                                                                                        item.id +
                                                                                        " - " +
                                                                                        item.nameDevice,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.id
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " - "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.nameDevice
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "name",
                                                                          label:
                                                                            "Nhập họ tên",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Nhập họ và tên",
                                                                                clearable:
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .name,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "name",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.name",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Chọn thiết bị nhận diện",
                                                                          prop: "idDeviceList",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                "collapse-tags":
                                                                                  "",
                                                                                multiple: true,
                                                                                placeholder:
                                                                                  "Chọn thiết bị nhận diện",
                                                                                "value-key":
                                                                                  "id",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleDeviceListChange,
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .idDeviceList,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "idDeviceList",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.idDeviceList",
                                                                              },
                                                                          },
                                                                          _vm._l(
                                                                            _vm.listIdDevice,
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key: item.id,
                                                                                  attrs:
                                                                                    {
                                                                                      value:
                                                                                        item.id,
                                                                                      label:
                                                                                        item.id +
                                                                                        " - " +
                                                                                        item.nameDevice,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.id
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " - "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.nameDevice
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "startTime",
                                                                          label:
                                                                            "Chọn ngày bắt đầu",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-date-picker",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                format:
                                                                                  "dd-MM-yyyy",
                                                                                type: "date",
                                                                                "value-format":
                                                                                  "yyyy-MM-dd",
                                                                                placeholder:
                                                                                  "Chọn ngày bắt đầu",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleStartDateChange(
                                                                                    _vm
                                                                                      .kidFaceManagement
                                                                                      .startTime
                                                                                  )
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .startTime,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "startTime",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.startTime",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "endTime",
                                                                          label:
                                                                            "Chọn ngày kết thúc",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-date-picker",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                format:
                                                                                  "dd-MM-yyyy",
                                                                                "value-format":
                                                                                  "yyyy-MM-dd",
                                                                                type: "date",
                                                                                placeholder:
                                                                                  "Chọn ngày kết thúc",
                                                                                "picker-options":
                                                                                  _vm.endDateOptions,
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .endTime,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "endTime",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.endTime",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.checkPermission([
                                                  "recognition-manager-card-student",
                                                ])
                                                  ? _c(
                                                      "el-row",
                                                      {
                                                        staticClass:
                                                          "ai-section ai-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 24 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-counter-title",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Thẻ vật lý"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.numberCard
                                                                      ) +
                                                                        "/" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .kidFaceManagement
                                                                            .cardNumber
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm.cardList,
                                                                  function (
                                                                    card,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "el-col",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "ai-item-col",
                                                                        attrs: {
                                                                          span: 6,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-card-item",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-card-content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-text",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            card.cardName
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "ID: " +
                                                                                            _vm._s(
                                                                                              card.cardNo
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "No: " +
                                                                                            _vm._s(
                                                                                              card.cardCodeShow
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-icon",
                                                                                    attrs:
                                                                                      {
                                                                                        src: require("@/assets/card.png"),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "card-actions-overlay",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-edit action-btn edit",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleEditCard(
                                                                                                index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                    _vm.checkPermission(
                                                                                      [
                                                                                        "recognition-manager-delete-card-student",
                                                                                      ]
                                                                                    )
                                                                                      ? _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-delete action-btn delete",
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.handleDeleteCard(
                                                                                                    index
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    staticClass:
                                                                      "ai-item-col",
                                                                    attrs: {
                                                                      span: 6,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-add-item",
                                                                        on: {
                                                                          click:
                                                                            _vm.handledOpenAddCardDialog,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-plus",
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Thêm thẻ mới"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.checkPermission([
                                                  "recognition-manager-finger-student",
                                                ])
                                                  ? _c(
                                                      "el-row",
                                                      {
                                                        staticClass:
                                                          "ai-section ai-finger-section ai-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 24 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-counter-title",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Dữ liệu vân tay"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.numberFinger
                                                                      ) +
                                                                        "/" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .kidFaceManagement
                                                                            .fingerNumber
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm.listFinger,
                                                                  function (
                                                                    fp,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "el-col",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "ai-item-col",
                                                                        attrs: {
                                                                          span: 6,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-finger-item",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-card-content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-text",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            fp.fingerName
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "ID Vân tay: #" +
                                                                                            _vm._s(
                                                                                              fp.fingerNo
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-icon",
                                                                                    attrs:
                                                                                      {
                                                                                        src: require("@/assets/finger.png"),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "card-actions-overlay",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-edit action-btn edit",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleEditFinger(
                                                                                                fp
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-delete action-btn delete",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleDeleteFinger(
                                                                                                fp
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    staticClass:
                                                                      "ai-item-col",
                                                                    attrs: {
                                                                      span: 6,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-add-item",
                                                                        on: {
                                                                          click:
                                                                            _vm.handledOpenAddFingerDialog,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-plus",
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Thêm vân tay mới"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "ai-actions" },
                                                  [
                                                    !_vm.checkCreateRecognition
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "ai-btn-delete",
                                                            attrs: {
                                                              type: "danger",
                                                              size: "medium",
                                                              loading:
                                                                _vm.loadingButtonRecognition,
                                                              mini: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.deleteDataRecognition,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-circle-check",
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                "Xóa dữ liệu nhận diện"
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "ai-btn-submit",
                                                        attrs: {
                                                          disabled:
                                                            _vm.checkRecognition,
                                                          type: "success",
                                                          size: "medium",
                                                          loading:
                                                            _vm.loadingButtonRecognition,
                                                          mini: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.submitFormFaceManagement(
                                                              "faceManagement"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-check",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.titleButtonRecognition
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm.showButtonClick
            ? _c(
                "div",
                {
                  staticClass:
                    "tab-infor-button update-student-footer sk-dialog-footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: {
                        disabled: _vm.activeName === "faceManagement",
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("formAllTabStudent")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Lưu ý",
                visible: _vm.showWarning,
                width: "30%",
                "show-close": true,
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showWarning = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: {
                      "font-size": "60px",
                      color: "#e6a23c",
                      "margin-right": "15px",
                    },
                  }),
                  _c("div", [
                    _c(
                      "p",
                      { staticStyle: { "font-size": "16px", margin: "0" } },
                      [_vm._v(_vm._s(_vm.contentDevice))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Thêm người dùng cho thẻ",
                visible: _vm.dialogVisibleCard,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleCard = $event
                },
              },
            },
            [
              _c("div", [_c("span", [_vm._v("Tên người dùng")])]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập tên người dùng" },
                    model: {
                      value: _vm.cardName,
                      callback: function ($$v) {
                        _vm.cardName = $$v
                      },
                      expression: "cardName",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _c("span", [_vm._v("No")]),
              ]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập mã thẻ" },
                    model: {
                      value: _vm.cardCode,
                      callback: function ($$v) {
                        _vm.cardCode = $$v
                      },
                      expression: "cardCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.getInformationNumberCard },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseCard },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Sửa người dùng cho thẻ",
                visible: _vm.dialogVisibleEditCard,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleEditCard = $event
                },
              },
            },
            [
              _c("div", [_c("span", [_vm._v("Tên người dùng")])]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập tên người dùng" },
                    model: {
                      value: _vm.cardNameEdit,
                      callback: function ($$v) {
                        _vm.cardNameEdit = $$v
                      },
                      expression: "cardNameEdit",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _c("span", [_vm._v("No")]),
              ]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập mã thẻ", type: "number" },
                    model: {
                      value: _vm.cardCodeEdit,
                      callback: function ($$v) {
                        _vm.cardCodeEdit = $$v
                      },
                      expression: "cardCodeEdit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.saveInformationNumberCard(_vm.card)
                        },
                      },
                    },
                    [_vm._v("Lưu")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseEditCard },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Thêm tên người dùng cho dấu vân tay",
                visible: _vm.dialogVisibleFinger,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleFinger = $event
                },
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên người dùng" },
                model: {
                  value: _vm.fingerName,
                  callback: function ($$v) {
                    _vm.fingerName = $$v
                  },
                  expression: "fingerName",
                },
              }),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.getInformationFinger },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseFinger },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Sửa tên người dùng cho dấu vân tay",
                visible: _vm.dialogVisibleEditFinger,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleEditFinger = $event
                },
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên người dùng" },
                model: {
                  value: _vm.fingerNameEdit,
                  callback: function ($$v) {
                    _vm.fingerNameEdit = $$v
                  },
                  expression: "fingerNameEdit",
                },
              }),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.saveInformationEditFinger(_vm.finger)
                        },
                      },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseEditFinger },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CamSettingStudentDialog", {
        attrs: {
          showSettingCamera: _vm.showSettingCamera,
          idKids: _vm.idKids,
          idCamera: _vm.idCamera,
          nameCamera: _vm.nameCamera,
        },
        on: { close: _vm.handleCloseSettingCameraDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }